__turbopack_context__.v({
  "bannerImage": "heroSection-module__eX-C4a__bannerImage",
  "bannerSection": "heroSection-module__eX-C4a__bannerSection",
  "bannerSubtitle": "heroSection-module__eX-C4a__bannerSubtitle",
  "bannerText": "heroSection-module__eX-C4a__bannerText",
  "bannerTitle": "heroSection-module__eX-C4a__bannerTitle",
  "bannerTitleBlue": "heroSection-module__eX-C4a__bannerTitleBlue",
  "bannerTitleUnderline": "heroSection-module__eX-C4a__bannerTitleUnderline",
});
